<template>
  <div class="personal-info-card">
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm"
      :size="formSize"
      status-icon
    >

      <div class="first-title">个人资料设置</div>
      <div class="second-title">绝不会以任何形式向第三方透露您的身份信息</div>

      <!-- 头像 -->
      <el-form-item label="头像">
        <el-icon :size="20"><UserFilled /></el-icon>
        <!-- <el-upload
          class="avatar-uploader"
          action="#"
          :show-file-list="false"
        >
          <img class="avatar" :src="avatarUrl" alt="">
          <el-icon :size="20"><UserFilled /></el-icon>
        </el-upload> -->
      </el-form-item>

      <!-- 身份（系统标注，不可修改） -->
      <el-form-item v-if="roleText" label="身份">
        <el-tag :type="roleTagType" size="large" disable-transitions>{{ roleText }}</el-tag>
        <span v-if="userRole === 'teacher'" class="role-tip">老师账号可登录代理商后台管理学生，并可通过授权登录各子平台</span>
      </el-form-item>

      <!-- 昵称 -->
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="ruleForm.nickname" />
      </el-form-item>
      <!-- 常用邮箱 -->
      <el-form-item label="常用邮箱" prop="email">
        <el-input v-model="ruleForm.email" />
      </el-form-item>
      <!-- 手机号码 -->
      <!-- <el-form-item label="手机号码" prop="phone">
        <el-input v-model="ruleForm.phone" disabled />
      </el-form-item> -->
      <!-- 微信号 -->
      <el-form-item label="微信号" prop="wechatNo">
        <el-input v-model="ruleForm.wechatNo" />
      </el-form-item>
      <!-- 真实姓名 -->
      <el-form-item label="真实姓名" prop="name">
        <el-input v-model="ruleForm.name" />
      </el-form-item>

      <!-- 地区 -->
      <el-form-item label="地区" prop="district">
        <el-cascader v-model="ruleForm.district" :options="options" @change="handleChange" placeholder="请选择" style="width: 100%;"/>
      </el-form-item>

      <!-- 性别 -->
      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="ruleForm.gender">
          <el-radio value="1">男</el-radio>
          <el-radio value="2">女</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 在读学校 -->
      <el-form-item label="在读学校" prop="school">
        <el-input v-model="ruleForm.school" />
      </el-form-item>

      <!-- 在读年级 -->
      <el-form-item label="在读年级" prop="grade">
        <el-select v-model="ruleForm.grade" placeholder="请选择在读年级">
          <el-option
            v-for="item in gradeList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>

      <!-- 保存 -->
      <el-form-item>
        <div class="btn-container">
          <el-button type="primary" @click="submitForm(ruleFormRef)">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted } from 'vue'
import { SaveUserInfo, GetDict } from '@/api/api.js'
import { getAuthHandel, getUserInfo, removeAuthHandel, saveUserInfo } from '@/utils/common'
import dataJson from '@/assets/json/data2.json'
import { ElMessage } from 'element-plus'
import { useRoute } from 'vue-router';

const route = useRoute();

const formSize = ref('default')
const ruleFormRef = ref()
const ruleForm = reactive({
  // id 必填，前端不用管，随便写一个
  id: '111',
  // 昵称
  nickname: '',
  // 常用邮箱
  email: '',
  // 微信号
  wechatNo: '',
  // 真实姓名
  name: '',
  // 地区
  district: '',
  // 性别
  gender: '',
  // 在读学校
  school: '',
  // 在读年级
  grade: '',
})

// 地区
const options = dataJson

const rules = reactive({
  // 昵称
  nickname: [
  { required: true, message: '请输入昵称', trigger: 'blur' }
    // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' }
  ],
  // 常用邮箱
  // email: [
  //   { required: true, message: '请输入邮箱', trigger: 'blur' }
  //   // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' },
  // ],
  // 真实姓名
  name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
  phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
  wechat: [{ required: true, message: '请输入微信号', trigger: 'blur' }],
  // 地区
  district: [
    {
      required: true,
      message: '请选择地区',
      trigger: 'change'
    }
  ],
  // 在读学校
  school: [{ required: true, message: '请输入在读学校', trigger: 'change' }],
  // 在性别
  gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
  grade: [{ required: true, message: '请选择年级', trigger: 'change' }],
})

// 年级
let gradeList = ref([])
const authParams = getAuthHandel()

// 用户身份标注（老师/学生），来自登录返回的 role
const ROLE_TEXTS = { teacher: '老师', student: '学生' }
const cachedUser = getUserInfo()
const userRole = (cachedUser && cachedUser.role) || ''
const roleText = ROLE_TEXTS[userRole] || ''
const roleTagType = userRole === 'teacher' ? 'warning' : 'success'

//获取当前uri链接
const uri = route.path;

const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      //浅拷贝对象，需要修改内容
      const param = JSON.parse(JSON.stringify(ruleForm))
      param.district = param.district.join(',')
      SaveUserInfo(param).then((response) => {
        const res = response.data;
        console.log(res)
        if(res.code === 200){
          // 重新保存用户信息到缓存
          saveUserInfo(res.data)
          ElMessage({message: '保存成功', type: 'success'})
          if(authParams){
            removeAuthHandel()
            window.location.href='/auth/handle'+authParams;
          }else{
            setTimeout(() => {
              if(!uri.includes('personalRole')){
                window.location.href = '/'
              }
            }, 1000)
          }
          
        }
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}

// 所选地区
const handleChange = (value) => {
  console.log(value)
}

onMounted(() => {
  GetDict().then((res) => {
    gradeList.value = res.data.data.userGradeList
  }).then(() => {
    let userInfo = getUserInfo()
    if(userInfo){
      for (let key in ruleForm) {
        if (!userInfo[key]) continue
        ruleForm[key] = userInfo[key]
        if(key === 'district'){
          ruleForm[key] = userInfo[key].split(',')
        }
      }
    }
  })
})
</script>

<style scoped>
.personal-info-card {
  padding: 200px 0;
  background: url('@/assets/images/bg/bg-personalcenter.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  display: flex;
  justify-content: center;
}
.demo-ruleForm {
  width: 600px;
  padding: 100px;
  position: relative;
  border-radius: 26px;
  background-color: #eee;
  box-shadow: 0 0 10px #ccc;
  box-sizing: border-box;
}
.demo-ruleForm::before {
  content: "";
  display: block;
  width: 251px;
  height: 192px;
  position: absolute;
  top: 0;
  right: 0;
  background: url('@/assets/images/bg/bg-red.png') no-repeat;
  background-size: 100% 100%;
}
.demo-ruleForm::after {
  content: "";
  display: block;
  width: 259px;
  height: 170px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: url('@/assets/images/bg/bg-blue.png') no-repeat;
  background-size: 100% 100%;
}
.btn-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
.role-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}
.demo-ruleForm /deep/ .el-form-item__label {
  color: rgb(18,49,96);
}
.first-title {
  color: rgba(0, 50, 100, 1);
  font-size: 24px;
}
.second-title {
  color: rgba(150, 150, 150, 1);
  font-size: 12px;
  padding: 10px 0 30px 0;
}
</style>
